import { Loading } from "../Loading";
import { AppState } from "../system/AppState";
import { AppAgenciesState } from "../system/AppState/AppAgenciesState";
import { AppCaregiverState } from "../system/AppState/AppCaregiverState";
import { AppScheduledVisitsState } from "../system/AppState/AppScheduledVisitsState";
import { AppTaskBroadcastsState } from "../system/AppState/AppTaskBroadcastssState";
import { AppTasksState } from "../system/AppState/AppTasksState";
import { AppVisitEditRequestsState } from "../system/AppState/AppVisitEditRequestsState";
import { AppVisitsState } from "../system/AppState/AppVisitsState";
import { AppChatState } from "../system/AppState/ChatState";
import { NotificationState } from "../system/AppState/NotificationState";
import { EventSourceBinding } from "../system/EventSource";

export interface ActivityStateMixinState {
  appCaregiverState: AppCaregiverState | Loading;
  appVisitsState: AppVisitsState | Loading;
  appTasksState: AppTasksState | Loading;
  appVisitEditRequestsState: AppVisitEditRequestsState | Loading;
  appAgenciesState: AppAgenciesState | Loading;
  appChatState: AppChatState;
  notificationsState: NotificationState;
  scheduledVisits: AppScheduledVisitsState | Loading;
  appTaskBroadcastsState: Loading | AppTaskBroadcastsState;
}

export class ActivityStateMixin {
  constructor(setState: (state: ActivityStateMixinState) => void, private appState: AppState) {
    const updateState = (): void => {
      setState({
        appCaregiverState: appState.appCaregiverState,
        appVisitsState: appState.appVisitsState,
        appTasksState: appState.appTasksState,
        appVisitEditRequestsState: appState.appVisitEditRequestsState,
        appAgenciesState: appState.appAgenciesState,
        appChatState: appState.chatState.getAppChatState(),
        notificationsState: appState.notificationState,
        scheduledVisits: appState.scheduledVisits,
        appTaskBroadcastsState: appState.appTaskBroadcastsState,
      });
    };

    this.eventBindings.push(appState.onAgencyMembersUpdated.register(() => updateState()));
    this.eventBindings.push(appState.onCaregiverUpdated.register(() => updateState()));
    this.eventBindings.push(appState.onVisitsUpdated.register(() => updateState()));
    this.eventBindings.push(appState.onTasksUpdated.register(() => updateState()));
    this.eventBindings.push(appState.onTaskBroadcastsUpdated.register(() => updateState()));
    this.eventBindings.push(appState.onEditRequestUpdated.register(() => updateState()));
    this.eventBindings.push(appState.chatState.onAppChatStateChanged.register(() => updateState()));
    this.eventBindings.push(appState.onClockedInStatusUpdated.register(() => updateState()));
    this.eventBindings.push(
      appState.notificationState.onNotificationsUpdated.register(() => updateState())
    );
    this.eventBindings.push(appState.onScheduledVisitsUpdated.register(() => updateState()));
    this.eventBindings.push(appState.onPatientsUpdated.register(() => updateState()));
  }

  public componentWillUnmount() {
    for (const eventBinding of this.eventBindings) {
      eventBinding.unregister();
    }
  }

  public initialState(): ActivityStateMixinState {
    return {
      appCaregiverState: this.appState.appCaregiverState,
      appVisitsState: this.appState.appVisitsState,
      appVisitEditRequestsState: this.appState.appVisitEditRequestsState,
      appAgenciesState: this.appState.appAgenciesState,
      appChatState: this.appState.chatState.getAppChatState(),
      notificationsState: this.appState.notificationState,
      scheduledVisits: this.appState.scheduledVisits,
      appTasksState: this.appState.appTasksState,
      appTaskBroadcastsState: this.appState.appTaskBroadcastsState,
    };
  }

  public static initialState(appState: AppState): ActivityStateMixinState {
    return {
      appCaregiverState: appState.appCaregiverState,
      appVisitsState: appState.appVisitsState,
      appVisitEditRequestsState: appState.appVisitEditRequestsState,
      appAgenciesState: appState.appAgenciesState,
      appChatState: appState.chatState.getAppChatState(),
      notificationsState: appState.notificationState,
      scheduledVisits: appState.scheduledVisits,
      appTasksState: appState.appTasksState,
      appTaskBroadcastsState: appState.appTaskBroadcastsState,
    };
  }

  eventBindings: EventSourceBinding[] = [];
}
